import { getRequest } from '../../Common/network-call';
import { TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FIELDS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

export const APPUSER_ACCESS = 'APPUSER_ACCESS';
export const APPUSER_OWN_ORDERS = 'APPUSER_OWN_ORDERS';
export const APPUSER_ACCESSED_TICKETS = 'APPUSER_ACCESSED_TICKETS';

export const fetchUserAccess = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})`
  );
  let orderby = 'createdon%20DESC';
  let related =
    'orders_by_orderid,tickets_by_ticketid&orders_by_orderid.fields=orderid&tickets_by_ticketid.fields=ticketname';
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuseraccess}?fields=${FIELDS.appuseraccess.minInfo}&related=${related}&filter=(${filter})&order=${orderby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: APPUSER_ACCESS,
          payload: { resource: data.resource }
        });
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchOwnOrder = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(email=${session.emailid})AND(status=approve)`
  );
  let orderby = 'createdon%20DESC';
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.orders}?filter=(${filter})&order=${orderby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: APPUSER_OWN_ORDERS,
          payload: { resource: data.resource }
        });
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const setAccessedTickets = payload => {
  return dispatch => dispatch({ type: APPUSER_ACCESSED_TICKETS, payload });
};
